import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { navItems } from '../mock';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const renderLink = (item, onClick) => {
    // Anchor to homepage section
    if (item.href.startsWith('/#')) {
      if (location.pathname !== '/') {
        return (
          <Link
            to={`/${item.href.substring(1)}`}
            onClick={onClick}
            className="text-sm font-medium text-neutral-300 hover:text-[#E9C46A] link-transition relative group"
          >
            {item.label}
            <span className="absolute -bottom-1 left-0 w-0 h-[1.5px] bg-[#D4A94F] btn-transition group-hover:w-full" />
          </Link>
        );
      }
      return (
        <a
          href={item.href.substring(1)}
          onClick={onClick}
          className="text-sm font-medium text-neutral-300 hover:text-[#E9C46A] link-transition relative group"
        >
          {item.label}
          <span className="absolute -bottom-1 left-0 w-0 h-[1.5px] bg-[#D4A94F] btn-transition group-hover:w-full" />
        </a>
      );
    }
    // Regular route
    const active =
      location.pathname === item.href ||
      (item.href !== '/' && location.pathname.startsWith(item.href));
    return (
      <Link
        to={item.href}
        onClick={onClick}
        className={`text-sm font-medium link-transition relative group ${
          active ? 'text-[#E9C46A]' : 'text-neutral-300 hover:text-[#E9C46A]'
        }`}
      >
        {item.label}
        <span
          className={`absolute -bottom-1 left-0 h-[1.5px] bg-[#D4A94F] btn-transition ${
            active ? 'w-full' : 'w-0 group-hover:w-full'
          }`}
        />
      </Link>
    );
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 btn-transition ${
        scrolled
          ? 'bg-black/85 backdrop-blur-lg border-b border-[#D4A94F]/15'
          : 'bg-black/40 backdrop-blur-sm'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="relative">
            <img
              src="/logo-werdi-media.png"
              alt="Werdi Media"
              className="w-11 h-11 object-contain btn-transition group-hover:scale-105"
            />
            <div className="absolute inset-0 rounded-full bg-[#D4A94F]/25 blur-2xl glow-pulse -z-10" />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="text-white font-bold text-lg tracking-tight">Werdi Media</span>
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#D4A94F] font-medium">
              Music Distribution
            </span>
          </div>
        </Link>

        <ul className="hidden lg:flex items-center gap-7">
          {navItems.map((item) => (
            <li key={item.label}>{renderLink(item)}</li>
          ))}
        </ul>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="https://member.werdimedia.com"
            target="_blank"
            rel="noreferrer"
            className="text-sm font-medium text-neutral-200 hover:text-white link-transition"
          >
            Masuk
          </a>
          <Button
            asChild
            className="bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black hover:from-[#F0D078] hover:to-[#E1B85D] font-semibold px-6 rounded-full btn-transition gold-shimmer"
          >
            <Link to="/rilis-musik">Rilis Musik</Link>
          </Button>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {isOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-[#D4A94F]/15 px-6 py-6">
          <ul className="flex flex-col gap-4">
            {navItems.map((item) => (
              <li key={item.label}>{renderLink(item, () => setIsOpen(false))}</li>
            ))}
            <li className="pt-3">
              <Button
                asChild
                className="w-full bg-gradient-to-r from-[#E9C46A] to-[#D4A94F] text-black font-semibold rounded-full btn-transition"
              >
                <Link to="/rilis-musik" onClick={() => setIsOpen(false)}>
                  Rilis Musik
                </Link>
              </Button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
